<template>
    <div class="landlord-login">
        <landing-menu></landing-menu>
        <div class="landlord-login-wrap" v-bind:style="{'min-height': myHeight}">
            <div class="title">
                超過 <span class="mark">1000位房東</span> <br>使用飛豬管家後，大幅減少空房時間
            </div>
            <div class="wrap">
                <div class="woman">
                    <img src="https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/woman.png" alt="">
                </div>
                <login-comp class="login-comp"></login-comp>
            </div>
        </div>
        <landing-footer></landing-footer>
    </div>
</template>

<script>
import landingMenu from '@/components/officailPage/widges/menu/menu.vue';
import landingFooter from '@/components/officailPage/widges/footer.vue';
import loginComp from '@/components/landlord/login/loginComp.vue';
export default {
    data () {
        return {
            myHeight: (window.innerHeight-68) + 'px',
        }
    },
    components: {
        landingMenu,
        loginComp,
        landingFooter
    }
}
</script>

<style lang="scss" scoped>
    .landlord-login{
        position: relative;
        .landlord-login-wrap{
            position: relative;
            background: url('https://flypig-public.s3-ap-southeast-1.amazonaws.com/images/landingPage/login_bg.png');
            background-size: cover;
            .title{
                font-size: 32px;
                font-weight: bold;
                line-height: 1.94;
                letter-spacing: 2.18px;
                text-align: center;
                color: #353535;
                text-shadow: 12px 7px 8px rgba(150, 154, 162, 0.3);
                padding-top: 10px;
                .mark{
                    font-size: 46px;
                    letter-spacing: 2.44px;
                    color: #fff;
                }
            }
            .wrap{
                position: absolute;
                display: flex;
                align-items: flex-end;
                justify-content: space-between;
                width: 850px;
                bottom: 0;
                left: 50%;
                transform: translateX(-425px);
                .woman{
                    position: relative;
                    img{
                        width: 446px;
                    }
                }
                .login-comp{
                    position: relative;
                    bottom: 72px;
                }
            }
            
        }
    }
    @media screen and (max-height: 800px) {
        .landlord-login{
            .landlord-login-wrap{
                .title{
                    font-size: 30px;
                    .mark{
                        font-size: 40px;
                    }
                }
                .wrap{
                    width: 750px;
                    .woman{
                        img{
                            width: 354px;
                        }
                    }
                    .login-comp{
                        bottom: 36px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 800px) {
        .landlord-login{
            .landlord-login-wrap{
                min-height: unset !important;
                .title{
                    font-size: 22px;
                    .mark{
                        font-size: 32px;
                    }
                }
                .wrap{
                    position: relative;
                    width: 100%;
                    background: #fff;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    bottom: unset;
                    left: unset;
                    transform: unset;
                    top: 35px;
                    border-bottom: 6px solid #ebebeb;
                    .woman{
                        display: none;
                    }
                    .login-comp{
                        position: relative;
                        bottom: unset;
                    }
                }
                
            }
        }
    }
    @media screen and (max-width: 375px) {
        .landlord-login{
            .landlord-login-wrap{
                .title{
                    font-size: 20px;
                    .mark{
                        font-size: 28px;
                    }
                }
            }
        }
    }
    @media screen and (max-width: 320px) {
        .landlord-login{
            .landlord-login-wrap{
                .title{
                    font-size: 16px;
                    .mark{
                        font-size: 22px;
                    }
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/landlord/login/login.vue